import type { LayoutImage, StoryblokGalleryImage } from '@monoimin/sb-types';

export function prepareGalleryImageForLayout(
  image: StoryblokGalleryImage
): LayoutImage {
  return {
    src: image.url,
    alt: image.title,
    width: image.metadata?.width,
    height: image.metadata?.height,
  };
}

export default prepareGalleryImageForLayout;
